<ul class="select-main">
  {{each listOptions}}
    <li class="select-close item" skf-click="$parent.setBusiness('{{$value.name}}','{{$value.creditCode}}','{{fieldName}}')">
      <div>{{@$value.showName}}</div>
      <div class="info">
        <span>法人：{{$value.legalPersonName}}</span>
        <span class="split"></span>
        <span>经营状况：{{$value.regStatus}}</span>
      </div>
    </li>
  {{/each}}
</ul>